import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import { LeaveRequestsIndex, LeaveRequestsDetails } from './routes';

const LeaveRequestsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'LeaveRequests' */ './components/LeaveRequests'
		)
);

export default (store) => {
	return [
		{
			path: 'home/attendance-dashboard/leave-requests',
			element: (
				<AsyncLoading
					component={
						<LeaveRequestsLazy
							featureFlag="FeatureFlag:AttendanceExcusals"
							permission="CanViewStudentLeaveRequests"
						/>
					}
				/>
			),
			children: [LeaveRequestsIndex(store), LeaveRequestsDetails(store)],
		},
	];
};
